import { StrictMode } from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "./styles/_globals.scss";
import "./styles/_fonts.scss";

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root")
);
